import { NavLink } from 'react-router';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';

const BASE_URL = `/${routes.INTERNAL}`;
const title = 'Internal';
const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const getInternalMenuItems = () => {
    const menu = [
        {
            group: 'Demos',
            navItems: [
                {
                    key: 'buyButton',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/buyButton`}>
                            BuyButton
                        </NavLink>
                    ),
                    meta: 'buyButton',
                },
                {
                    key: 'calendarStripe',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/calendarStripe`}>
                            CalendarStripe
                        </NavLink>
                    ),
                    meta: 'calendarStripe custom calendar',
                },
                {
                    key: 'calendarTimeline',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/calendarTimeline`}>
                            CalendarTimeline
                        </NavLink>
                    ),
                    meta: 'calendar timeline schedule planning start end marker',
                },
                {
                    key: 'startHero',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/startHero`}>
                            StartHero
                        </NavLink>
                    ),
                    meta: 'start hero intro playground',
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const InternalMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
